//Basic Dropdown
export const DROPDOWN_DATA = [
  {
    text: "When the",
    code: ".show ",
  },
  {
    text: "class starts, dropdown appears. And ",
    code: ".btn-*",
  },
  {
    text: " to change button dark background colors. ",
  },
];

export const DROPDOWN_LIST = [
  {
    btnText: "Ecommerce",
    btnColor: "secondary",
    dropclassName: "dropdown-block",
    items: [
      {
        item: "Product",
      },
      {
        item: "Product details",
      },
      {
        item: "Cart",
      },
    ],
  },
  {
    btnText: "Ui kits",
    btnColor: "warning",
    dropclassName: "dropdown-block",
    items: [
      {
        item: "Typography",
      },
      {
        item: "Avatars",
      },
      {
        item: "Grid",
      },
    ],
  },
  {
    btnText: "Error page",
    btnColor: "danger",
    dropclassName: "dropdown-block",
    items: [
      {
        item: "Error 400",
      },
      {
        item: "Error 403",
      },
      {
        item: "Error 500",
      },
    ],
  },
];

//Rounded Dropdown
export const ROUNDED_DATA = [
  {
    text: "When the",
    code: ".show ",
  },
  {
    text: "class starts, dropdown appears. And ",
    code: "rounded-pill",
  },
  {
    text: " to change rounded dropdowns.",
  },
];

export const ROUNDED_LIST = [
  {
    btnText: "Success",
    btnColor: "success",
    dropclassName: "dropdown-block",
    toggleClassName: "rounded-pill",
    items: [
      {
        item: "Dark",
      },
      {
        item: "Light",
      },
      {
        item: "Lighter",
      },
    ],
  },
  {
    btnText: "Info",
    btnColor: "info",
    dropclassName: "dropdown-block",
    toggleClassName: "rounded-pill",
    items: [
      {
        item: "Dark",
      },
      {
        item: "Light",
      },
      {
        item: "Lighter",
      },
    ],
  },
  {
    btnText: "Warning",
    btnColor: "warning",
    dropclassName: "dropdown-block",
    toggleClassName: "rounded-pill",
    items: [
      {
        item: "Dark",
      },
      {
        item: "Light",
      },
      {
        item: "Lighter",
      },
    ],
  },
  {
    btnText: "Danger",
    btnColor: "danger",
    dropclassName: "dropdown-block",
    toggleClassName: "rounded-pill",
    items: [
      {
        item: "Dark",
      },
      {
        item: "Light",
      },
      {
        item: "Lighter",
      },
    ],
  },
];

//Split Dropdown
export const SPLIT_DATA = [
  {
    text: "When the",
    code: ".show ",
  },
  {
    text: "class starts, dropdown appears. And split the dropdown ",
    code: ".dropdown-toggle-split",
  },
];

export const SPLIT_LIST = [
  {
    items: [{ item: "Animate" }, { item: "AOS animation" }],
    btnText: "Secondary Button",
    btnColor: "secondary",
  },
  {
    items: [{ item: "Echarts" }, { item: "Apex chart" }],
    btnText: "Success Button",
    btnColor: "success",
  },
  {
    items: [{ item: "Email app" }, { item: "Email compose" }],
    btnText: "Info Button",
    btnColor: "info",
  },
  {
    items: [{ item: "Flag icons" }, { item: "Fontawesome icons" }, { item: "Ico icons" }, { item: "Feather icons " }],
    btnText: "Warning Button",
    btnColor: "warning",
  },
  {
    items: [{ item: "Learning List" }, { item: "Detailed Course" }],
    btnText: "Danger Button",
    btnColor: "danger",
  },
];

//Heading dropdown
export const HEADING_DATA = [
  {
    text: "Main heading and any sub-content in dropdown.",
  },
];

//With input type
export const WITH_INPUT_DATA = [
  {
    text: "Main heading and any sub-content in dropdown.",
  },
];

//Dark Dropdown
export const DARK_DATA = [
  {
    code: ".dropdown-menu-dark ",
  },
  {
    text: "class through make dark mode.",
  },
];

//Unique Dropdown
export const UNIQUE_DATA = [
  {
    text: "Unique way to represent form dropdown and text dropdown.",
  },
];

//Justify Contents
export const JUSTIFY_DATA = [
  {
    text: "Use the",
    code: "(text-start/text-center/text-end)",
  },
  {
    text: " to change dropdown texts.",
  },
];

export const JUSTIFY_LIST = [
  {
    items: [{ item: "Chocolate" }, { item: "Ice-cream" }, { item: "Trophy" }],
    btnText: "Text-center",
    btnColor: "info",
    dropclassName: "dropdown-block text-center",
  },
  {
    items: [{ item: "I'm fine." }, { item: "ohh wow!" }, { item: "That's the good news! " }],
    btnText: "Text-center",
    btnColor: "primary",
    dropclassName: "dropdown-block text-end",
  },
];

//Alignments
export const ALIGNMENT_DATA = [
  {
    text: "Use the",
    code: "(text-start/text-center/text-end)",
  },
  {
    text: " to change dropdown texts.",
  },
];

export const ALIGNMENT_LIST = [
  {
    items: [{ item: "Good luck" }, { item: "Good job" }, { item: "Done!" }],
    btnText: "Success right",
    btnColor: "success",
    direction: "right",
    dropclassName: "dropdown-block text-end",
  },
  {
    items: [{ item: "It's important" }, { item: "Happy life " }, { item: "Another work" }],
    btnText: "Primary bottom",
    btnColor: "primary",
    direction: "down",
    dropclassName: "dropdown-block text-end",
  },
  {
    items: [{ item: "Threat" }, { item: "Dangerous" }, { item: "Alert" }],
    btnText: "Danget left",
    btnColor: "danger",
    direction: "left",
    dropclassName: "dropdown-block text-start",
  },
];

//Helper Card
export const HELPER_DATA = [
  {
    text: "When the",
    code: ".show ",
  },
  {
    text: "class starts, dropdown appears.",
  },
];

//Divider Dropdown
export const DIVIDER_DATA = [
  {
    text: "When the",
    code: ".show ",
  },
  {
    text: "class starts, dropdown appears.",
    code: ".dropdown-divider",
  },
  {
    tetx: " to change dropdown section.",
  },
];

export const DIVIDER_SPORT_DATA = [
  {
    items: [{ item: "Badminton" }, { item: "Tenis" }, { item: "Kho-Kho",divider: true},{item:"Separated link"}],
    btnText: "Sports",
    btnColor: "primary",
    dropclassName: "dropdown-block",
    toggleClassName: "rounded-pill",
    
  },
  {
    items: [{ item: "Orange" }, { item: "Red" }, { item: "Another work",divider: true },{item:"Separated link"}],
    btnText: "Colors",
    btnColor: "secondary",
    dropclassName: "dropdown-block",
    toggleClassName: "rounded-pill",
  },
];

//Dropdown Sizing
export const SIZING_DATA = [
  {
    text: "When the",
    code: ".show ",
  },
  {
    text: "class starts, dropdown appears. And ",
    code: "[.btn-lg/.btn-sm]",
  },
  {
    tetx: "class through button size changed.",
  },
];

export const SIZING_LIST = [
  {
    items: [{ item: "Small button " }, { item: "Very small button " }, { item: "Extra small button",divider: true},{item:"Extra extra small"}],
    btnText: "small button",
    btnColor: "dark",
    dropclassName: "dropdown-block",
    size:"sm"
  },
];
